import React, { useState } from 'react';
import { ReactComponent as UploadCsv } from 'assets/images/upload.svg';
import { useTranslation } from 'react-i18next';
import Modal from 'components/modal/Modal';
import SubmitQuotationModal from './SubmitQuotationModal/SubmitQuotationModal';
import { openMigrationModal } from 'store/slices/migrationModal.slice';
import useIsProductionHost from 'utils/hooks/useIsProductionHost';
import { ROLE_SELLER } from 'utils/constants/roles';
import { usePermission } from 'utils/usePermission';
import { useDispatch } from 'react-redux';

const c = 'automotor-menu-navbar';

const MenuSubmitQuotation: React.FC = () => {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const isProductionHost = useIsProductionHost();
  const dispatch = useDispatch();
  const isRoleSeller = usePermission([ROLE_SELLER]);

  const handleSubmitQuotation = () => {
    // if(isProductionHost && !isRoleSeller){
    //   dispatch(openMigrationModal());
    // }else{
      setIsOpen(true);
    // }
  };

  return (
    <React.Fragment>
      <div onClick={handleSubmitQuotation} className={`${c}__item--parent__children__item--title`}>
        <UploadCsv />
        <span>{t('_submit_quotation')}</span>
      </div>
      <Modal
        openModal={isOpen}
        setOpenModal={setIsOpen}
        childrenComponent={<SubmitQuotationModal setOpenModal={setIsOpen} />}
      />
    </React.Fragment>
  );
};

export default MenuSubmitQuotation;
